import React from 'react';
import { CellValue, WinningLine } from '../types';
import Cell from './Cell';
import './Board.css';

interface BoardProps {
  squares: CellValue[];
  winningLine: WinningLine;
  onClick: (index: number) => void;
}
/**
 * write a description for the Board component
 * the board component is a 3x3 grid of cells
 * it takes in a squares array of CellValue and a winningLine array of numbers
 * it also takes in an onClick function that is called when a cell is clicked
 * it returns a div element that contains the board
 * 
 * @param squares 
 * @param winningLine 
 * @param onClick 
 * @returns 
 */
const Board: React.FC<BoardProps> = ({ squares, winningLine, onClick }) => {
  const renderCell = (index: number) => {
    const isWinningCell = winningLine?.includes(index);
    return (
      <Cell
        key={index}
        value={squares[index]}
        isWinning={isWinningCell}
        onClick={() => onClick(index)}
      />
    );
  };

  return (
    <div className="board">
      <div className="board-row">
        {renderCell(0)}
        {renderCell(1)}
        {renderCell(2)}
      </div>
      <div className="board-row">
        {renderCell(3)}
        {renderCell(4)}
        {renderCell(5)}
      </div>
      <div className="board-row">
        {renderCell(6)}
        {renderCell(7)}
        {renderCell(8)}
      </div>
    </div>
  );
};

export default Board;
